import React, { useState, useEffect } from "react";
import { MultiSelect } from "react-multi-select-component";

export const MultiSelectCentra = ({ ...props }) => {
  const [selected, setSelected] = useState([]);
  const multiselectDict = props.multiselectDictionary;

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    const sportaanbod = queryParams.get(props.paramKey);
    const decodedSportaanbod = decodeURIComponent(sportaanbod);
    const sportsList = decodedSportaanbod.split(',');

    if (decodedSportaanbod !== "null") {
      const sportsObjects = sportsList.map(sport => ({
        label: sport,
        value: sport,
        disabled: false
      }));
      setSelected(sportsObjects);
    }
  }, [])

  useEffect(() => {

  }, [selected]);

  const handleChangeMultiSelect = (selected) => {
    let url = new URL(window.location);
    var params = new URLSearchParams(url.search);
    params.delete(props.paramKey);
    params.delete("p");

    const values = selected.map(s => s.value);

    if (values.length > 0)
      params.append(props.paramKey, values);

    window.history.replaceState({}, '', `${url.pathname}?${params.toString()}`);
    setSelected(selected);
  }

  return (
    <div class="c-input c-multiselect">
      {selected.length ? <label class="c-input__label">{multiselectDict.placeholder}</label> : <></>}
      <div>
        <MultiSelect
          options={props.options}
          value={selected}
          onChange={handleChangeMultiSelect}
          labelledBy="Select"
          overrideStrings={{
            "allItemsAreSelected": `${multiselectDict.allItemsSelected}`,
            "clearSearch": `${multiselectDict.clearSearch}`,
            "clearSelected": `${multiselectDict.clearSelected}`,
            "noOptions": `${multiselectDict.noOptions}`,
            "search": `${multiselectDict.search}`,
            "selectAll": `${multiselectDict.all}`,
            "selectAllFiltered": `${multiselectDict.selectAllFiltered}`,
            "selectSomeItems": `${multiselectDict.placeholder}`,
          }}
        />
      </div>
    </div>
  );
};

